// Format Money

let formatMoney = function (cents, format) {
  if (typeof cents == 'string') {
    cents = cents.replace('.', '')
  }
  var value = ''
  var placeholderRegex = /\{\{\s*(\w+)\s*\}\}/
  var formatString = format || this.money_format

  function defaultOption (opt, def) {
    return typeof opt == 'undefined' ? def : opt
  }

  function formatWithDelimiters (number, precision, thousands, decimal) {
    precision = defaultOption(precision, 2)
    thousands = defaultOption(thousands, ',')
    decimal = defaultOption(decimal, '.')

    if (isNaN(number) || number == null) {
      return 0
    }

    number = (number / 100.0).toFixed(precision)

    var parts = number.split('.'),
      dollars = parts[0].replace(/(\d)(?=(\d\d\d)+(?!\d))/g, '$1' + thousands),
      cents = parts[1] ? decimal + parts[1] : ''

    return dollars + cents
  }

  switch (formatString.match(placeholderRegex)[1]) {
    case 'amount':
      value = formatWithDelimiters(cents, 2)
      break
    case 'amount_no_decimals':
      value = formatWithDelimiters(cents, 0)
      break
    case 'amount_with_comma_separator':
      value = formatWithDelimiters(cents, 2, '.', ',')
      break
    case 'amount_no_decimals_with_comma_separator':
      value = formatWithDelimiters(cents, 0, '.', ',')
      break
  }

  return formatString.replace(placeholderRegex, value)
}

function cartMoneyFormat (cents, format) {
  if (typeof cents == 'string') {
    cents = cents.replace('.', '')
  }
  var value = ''
  var placeholderRegex = /\{\{\s*(\w+)\s*\}\}/
  var formatString = format || this.money_format

  function defaultOption (opt, def) {
    return typeof opt == 'undefined' ? def : opt
  }

  function formatWithDelimiters (number, precision, thousands, decimal) {
    precision = defaultOption(precision, 2)
    thousands = defaultOption(thousands, ',')
    decimal = defaultOption(decimal, '.')

    if (isNaN(number) || number == null) {
      return 0
    }

    number = (number / 100.0).toFixed(precision)

    var parts = number.split('.'),
      dollars = parts[0].replace(/(\d)(?=(\d\d\d)+(?!\d))/g, '$1' + thousands),
      cents = parts[1] ? decimal + parts[1] : ''

    return dollars + cents
  }

  switch (formatString.match(placeholderRegex)[1]) {
    case 'amount':
      value = formatWithDelimiters(cents, 2)
      break
    case 'amount_no_decimals':
      value = formatWithDelimiters(cents, 0)
      break
    case 'amount_with_comma_separator':
      value = formatWithDelimiters(cents, 2, '.', ',')
      break
    case 'amount_no_decimals_with_comma_separator':
      value = formatWithDelimiters(cents, 0, '.', ',')
      break
  }

  return formatString.replace(placeholderRegex, value)
}

function productItemAddToCart (product, event) {
  $(event.target).closest('.product-add').find('.spinner').show()
  let productData = {
    quantity: 1,
    id: product
  }
  $(event.target).find('.spinner').css({ opacity: 1, visibility: 'visible' })
  addToCartAjax(productData, event, { cart_drawer: 'open' })
}

function addToCartAjax (productData, event, options = null) {
  //add disable
  //   $(event.target).prop("disabled", true);
  //enable loader
  if ($(event.target).find('.add-to-cart-loader').length > 0) {
    $(event.target)
      .find('.add-to-cart-loader')
      .css({ opacity: 1, visibility: 'visible' })
  }
  if ($(event.target).next('.add-to-cart-loader').length > 0) {
    $(event.target)
      .next('.add-to-cart-loader')
      .css({ opacity: 1, visibility: 'visible' })
  }
  $(event.target).closest('.product-add').find('.spinner').show()
  if (options['purpose'] == 'quick-view') {
    $('.quickview-modal').find('.stock-avail').hide()
  } else {
    $('.single-product').find('.stock-avail').hide()
  }
  $.ajax({
    url: '/cart/add.js',
    type: 'POST',
    data: productData,
    dataType: 'json',
    success: function (res) {
      if (options['cart_drawer'] == 'open') {
        $(event.target).closest('.product-add').find('.spinner').hide()
        $(event.target)
          .closest('.product-add')
          .find('.added-span-product')
          .show()
        setTimeout(function () {
          $(event.target)
            .closest('.product-add')
            .find('.added-span-product')
            .hide()
        }, 5000)
        updateCartNumber()
      }
      if (options['redirect_to_cart'] == true) {
        setTimeout(function () {
          window.location.href = '/cart'
        }, 1000)
      }
      if (options['redirect_to_checkout'] == true) {
        setTimeout(function () {
          window.location.href = '/checkout'
        }, 1000)
      } else {
        if ($('.button-wrap').attr('data-cart') == 'page') {
          window.location.href = `/cart`
        }
      }
    },
    error: function (xhr, ajaxOptions, thrownError) {
      //add or update attribute of added quantity for that product
      //quick view
      if (options['purpose'] == 'quick-view') {
        let id = $(
          '.quickview-modal .single-product #product-select option:selected'
        ).val()
        let max = parseInt(
          $(
            '.quickview-modal .single-product .quantity-view .input-number'
          ).attr('max')
        )
        let in_cart = parseInt(
          $(`.cart-drawer .cart-row-block .input-number[data-id='${id}']`).val()
        )
        let left
        left = 0
        if (!isNaN(in_cart)) {
          left = max - in_cart
        }

        let text = `Sorry ${left} stock available`
        $(document).find('.quickview-modal .stock-avail').text(text)
        $(document).find('.quickview-modal .stock-avail').show()
        $('.single-product-buttons')
          .find('a:not(.sold-out)')
          .prop('disabled', false)
        $('.single-product-buttons')
          .find('.spinner')
          .css({ opacity: 0, visibility: 'hidden' })
      } else if (options['purpose'] == 'collection-list') {
        $(event.target).hide()
        $(event.target).parent().find('.spinner').hide()
        $(event.target).next('.stock-avail').show()
      } else {
        $('.spinner').hide()

        let id = $('.single-product #product-select option:selected').val()
        let max = parseInt(
          $('.single-product .quantity-view .input-number').attr('max')
        )
        let in_cart
        if ($('.cart-drawer').length > 0) {
          in_cart = parseInt(
            $(
              `.cart-drawer .cart-row-block .input-number[data-id='${id}']`
            ).val()
          )
        } else if ($('.mini-cart').length > 0) {
          in_cart = parseInt(
            $(
              `.mini-cart .mini-cart-details .input-number[data-id='${id}']`
            ).val()
          )
          $('.product-add').find('.spinner').hide()
        } else {
          jQuery.getJSON('/cart.js', function (cart) {
            // now have access to Shopify cart object
            for (var item in cart.items) {
              if (cart.items[item].id == id) {
                in_cart = parseInt(cart.items[item].quantity)

                let left
                left = 0
                if (!isNaN(in_cart)) {
                  left = max - in_cart
                }
                let text = `Sorry ${left} stock available`
                $(document)
                  .find('.single-product-stock-avail.stock-avail')
                  .text(text)
                $(document)
                  .find('.single-product-stock-avail.stock-avail')
                  .show()
                //remove disabled attribute
                $('.product-add')
                  .find('input:not(.sold-out)')
                  .prop('disabled', false)
                //remove loader
                $('.product-add').find('.spinner').hide()
              }
            }
          })
        }
        if ($('.cart-drawer').length > 0 || $('.mini-cart').length > 0) {
          let left
          left = 0
          if (!isNaN(in_cart)) {
            left = max - in_cart
          }
          let text = `Sorry ${left} stock available`
          $(document).find('.single-product-stock-avail.stock-avail').text(text)
          $(document).find('.single-product-stock-avail.stock-avail').show()
          //remove disabled attribute
          $('.product-add').find('input:not(.sold-out)').prop('disabled', false)
          //remove loader
          $('.product-add').find('.spinner').hide()
        }
      }
    }
  })
}

function updateCartNumber () {
  $.ajax({
    type: 'GET',
    url: '/cart.js',
    dataType: 'json',
    success: function (resultData) {
      $('.cart-icon .cart-count').text(resultData.item_count)
    }
  })
}

// Custom

$('.mobile-menu-close').click(function () {
  $('.header_container').removeClass('header-mobile-open')
}),
  (themFunction = {
    init: function () {
      themFunction.closeModal(),
        themFunction.inputNumber($(document).find('.input-number'))
    },
    closeModal: function () {
      $(document).on('click', function (e) {
        let o = [
          {
            open_class: 'open-drawer',
            close_class: 'cart-drawer-close',
            inner_class: 'cart-product',
            modal_class: 'cart-drawer',
            remove_class: 'cart-drawer-open'
          },
          {
            open_class: 'product-photos',
            close_class: 'single-product-zoom .remove',
            inner_class:
              'p-zooms, .slider-product-zoom .swiper-button-next, .slider-product-zoom .swiper-button-prev, .slider-product-zoom .video',
            modal_class: 'single-product-zoom',
            remove_class: 'product-zoom-open'
          },
          {
            open_class: 'small-box',
            close_class: 'location-currency-wrapper .tracker-close',
            inner_class: 'location-currency-wrapper',
            modal_class: 'location-currency-wrapper',
            remove_class: 'wrap-open'
          }
        ]
        for (i = 0; i < o.length; i++)
          ($(e.target).closest(`.${o[i].close_class}`).length > 0 ||
            (0 == $(e.target).closest(`.${o[i].open_class}`).length &&
              0 == $(e.target).closest(`.${o[i].inner_class}`).length)) &&
            (('quickview-modal' == o[i].modal_class &&
              $('.cart-drawer').hasClass('cart-drawer-open')) ||
              $(document)
                .find(`.${o[i].modal_class}`)
                .removeClass(`${o[i].remove_class}`),
            'open-drawer' == o[i].open_class &&
              $('body').removeClass('no-scroll'))
      })
    },
    inputNumber: function () {
      $(document).on('click', '.input-number-decrement', function () {
        let e = $(this).closest('.quantity-view').find('.input-number'),
          o = parseInt(e.attr('value')) - 1
        parseInt(e.attr('max')),
          o >= parseInt(e.attr('min')) &&
            (e.attr('value', o),
            'page' == $('.button-wrap').attr('data-cart')) &&
            $('#product-select option:selected').val()
      }),
        $(document).on('click', '.input-number-increment', function () {
          let e = $(this).closest('.quantity-view').find('.input-number'),
            o = parseInt(e.attr('value')) + 1,
            t = parseInt(e.attr('max'))
          parseInt(e.attr('min')),
            o <= t &&
              (e.attr('value', o),
              'page' == $('.button-wrap').attr('data-cart')) &&
              $('#product-select option:selected').val()
        })
    }
  })

function checkIfJqueryLoaded () {
  TweenMax.fromTo(
    $('.page-loader'),
    0.1,
    { opacity: 1, visibility: 'visible' },
    { opacity: 0, visibility: 'hidden' }
  ),
    themFunction.init(),
    (screensize = $(window).width()),
    jQuery('.simple-dropdown span').click(function () {
      jQuery('.dropdown-menu').addClass('menu-open')
    }),
    jQuery('.simple-dropdown-submenu span').click(function () {
      jQuery('.simple-dropdown-menu').addClass('menu-open')
    }),
    $(document).on('click', '.small-box', function () {
      $('.location-currency-wrapper ').toggleClass('wrap-open')
    })
}

checkIfJqueryLoaded()
;(window.onbeforeunload = function (e) {
  $(document.activeElement).hasClass('no-page-load-animation') ||
    TweenMax.fromTo(
      $('.page-loader'),
      0.1,
      { opacity: 0, visibility: 'hidden' },
      { opacity: 1, visibility: 'visible' }
    )
}),
  $(document).on('click', 'a', function (e) {})

jQuery('li.search-user').click(function () {
  jQuery('.search-wrapper').addClass('show-search'),
    jQuery('body').addClass('show-overlay-view')
  jQuery('#search-field').focus()
}),
  jQuery('.search-remove').click(function () {
    jQuery('.search-wrapper').removeClass('show-search')
  }),
  jQuery('.product-buy a').click(function (e) {
    $(this).parent().find('.spinner').show()
  }),
  jQuery('.hamburger-menu').click(function () {
    jQuery('.header_container').addClass('header-mobile-open')
  })

function focalPoint(){
let focalPoints = document.querySelectorAll('.focal__item')
if (focalPoints && !window.matchMedia("(max-width:768px").matches) {
  focalPoints.forEach(focalPoint => {
    let btn = focalPoint.querySelector('.focal-button')
    if (btn) {
      btn.addEventListener('click', e => {
        e.preventDefault()
        focalPoint.classList.toggle('focal-active')
      })
    }
  })
}
}

focalPoint()

window.addEventListener("resize",(e)=>{
  focalPoint()
})